module.exports = __webpack_public_path__ + "4af1c9e6792e9a73e7fc2e7ebbdc6d28.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/partials/icon-mail.svg
// module id = ./assets/images/partials/icon-mail.svg
// module chunks = 0